import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from 'store'
// import startServer from 'server';

// console.log = console.info = console.warn = console.error = console.debug = () => {};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
